module.exports = __webpack_public_path__ + "img/1F1FD-1F1F0.abeb49a3.svg";